import React from "react";
import SaasProductWizard from "../index";

function TSPlusWizard() {
  return <SaasProductWizard productType="tsplus" />;
}

export default TSPlusWizard;